<template>
  <div ref="main_div" class="tab-container">
    <div class="inner-tab-container">
      <div class="position-title">{{ list_heading_title }}</div>
      <div v-for="(value, key) in pos_status.value" :key="key" class="position-container">
        <template v-if="value.status == 1 && key != 10 && key != 13 && key != 60">
          <div :class="{ 'position-container-header': true, open: status[key] }" @click="toggle_position(key)">
            <div class="middle">{{ getTitle(key) }}</div>
            <div class="left">
              <img v-if="!status[key]" src="../assets/images/Strelica_narandzasta_dole.svg" alt />
              <img v-else src="../assets/images/Strelica_narandzasta_gore.svg" alt />
            </div>
          </div>
          <div :ref="'intervention' + key" class="intervention">
            <div class="top-intervention">
              <div class="frame">
                <div class="frame-text">
                  {{ app_sklopovi_a.select[value.top_image] }}
                </div>
              </div>
            </div>
            <div class="bottom-intervention">
              <div class="frame">
                <div class="frame-title">{{ uppercase(list_intervention_title) }}</div>
                <img :src="current_materijal[key] ? current_materijal[key] : default_materijal[key]" alt="" />
                <div
                  :key="'materijal' + value.top_image + '_' + materijal + '_' + index"
                  class="materijal-frame"
                  v-for="(materijal, index) in app_country_materijal.data[value.top_image][
                    value.bottom_image === 'b' || value.bottom_image === 'c' ? value.bottom_image : 'b'
                  ]"
                >
                  <div class="materijal-left" @click="set_image(materijal, key)">
                    <div class="materijal-title">{{ app_materijali.title[materijal] }}</div>
                    <div class="materijal-dimenzija">{{ app_materijali.select[materijal] }}</div>
                  </div>
                  <div class="materijal-right">
                    <img
                      src="../assets/images/external-link-symbol.svg"
                      alt=""
                      @click="gotolink(app_materijali.data[materijal].web)"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>

    <div class="tab-footer">
      <div class="inner left" @click="routechange(2)">
        <span>
          {{ app_back }}
          <div class="arrow left">
            <img src="../assets/images/Strelica_Back.svg" alt="left" />
          </div>
        </span>
      </div>
      <div class="inner right" @click="routechange(4)">
        <span>
          {{ app_next }}
          <div class="arrow right">
            <img src="../assets/images/Strelica_Next.svg" alt="left" />
          </div>
        </span>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.tab-container {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  background-color: $lighter_background;

  .inner-tab-container {
    flex: 1 0 1%;
  }

  .position-title {
    font-size: 2rem;
    padding: 1.8rem 0 3.2rem 0;
    text-align: center;
    line-height: 2.6rem;
    color: $list_back;
    font-family: "F-Dem";
    font-weight: bold;
  }

  .position-container {
    margin-left: 1.5rem;
    margin-right: 1.5rem;
    margin-bottom: 0.8rem;

    .position-container-header {
      height: 6rem;
      border-radius: 3rem;
      display: flex;
      background-color: $list_back;

      &.open {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
      }

      .right {
        flex: 0 0 2.45rem;
        margin-right: 1.9rem;
        margin-left: 1.9rem;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .middle {
        flex: 1 1 auto;
        justify-content: left;
        align-items: center;
        text-align: left;
        display: flex;
        font-family: "F-Std";
        font-size: 1.8rem;
        line-height: 1.28;
        letter-spacing: 0.5px;
        text-align: left;
        color: $text_white;
        padding-left: 2.7rem;
      }

      .left {
        margin-left: 2.25rem;
        margin-right: 2.45rem;
        flex: 0 0 1.8rem;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    .intervention {
      background-color: $darker_background;
      border-bottom-left-radius: 3rem;
      border-bottom-right-radius: 3rem;
      color: $text_dark;
      font-size: 1.5rem;
      line-height: 1.27;
      letter-spacing: 0.4px;
      max-height: 0;
      overflow: hidden;
      transition: max-height 0.2s ease-out;

      .top-intervention {
        background-color: $list_back;

        .frame {
          padding: 0 2.2rem 4.2rem 2.2rem;
          color: $lighter_background;
        }

        img {
          position: absolute;
          top: calc(100% - 7.5rem);
          width: 15rem;
          height: 15rem;
          object-fit: contain;
          left: calc(50% - 7.5rem);
        }
      }

      .bottom-intervention {
        background-color: $darker_background;
        margin-top: -2.5rem;
        border-top-left-radius: 2.5rem;
        border-top-right-radius: 2.5rem;

        .frame {
          padding: 2.5rem 2.2rem 0 2.2rem;
          color: $text_dark;
          text-align: center;

          img {
            width: 85%;
            max-width: 85%;
            height: auto;
          }
        }

        .frame-title {
          color: $list_back;
          font-family: F-Dem;
          font-weight: bold;
          font-size: 1.6rem;
          line-height: 1.69;
          letter-spacing: 0.4px;
        }

        .materijal-frame {
          display: flex;
          text-align: left;
          color: $text_dark;
          margin-bottom: 2.3rem;

          .materijal-left {
            flex: 0 0 80%;

            .materijal-title {
              font-family: F-Dem;
              font-weight: bold;
              font-size: 1.8rem;
              font-weight: bold;
              line-height: 1.28;
              letter-spacing: normal;
            }

            .materijal-dimenzija {
              font-size: 1.6rem;
              line-height: 1.38;
            }
          }

          .materijal-right {
            flex: 0 0 20%;
            display: flex;
            align-items: center;
            justify-content: flex-end;

            img {
              width: 50%;
              max-width: 50%;
              height: auto;
            }
          }
        }
      }

      .title {
        padding-top: 1.1rem;
        padding-bottom: 2rem;
        font-size: 1.8rem;
        font-weight: 500;
        line-height: 1.28;
        letter-spacing: 0.5px;
        text-align: center;
      }

      .left {
        flex: 0 0 46.86%;
        padding-right: 1.2rem;
      }

      .right {
        flex: 1 0 1%;
        padding-left: 2rem;
        padding-right: 1.1rem;
        background-color: $lighter_background;
        border-radius: 1.5rem;

        .title {
          color: $list_back;
        }
      }
    }
  }

  .tab-footer {
    flex: 0 0 auto;
    margin-top: 8rem;

    .inner.right {
      background: $list_back;
    }
  }
}
</style>

<script>
import mixin from "../lib/mixins.js";

export default {
  props: [
    "app_back",
    "app_next",
    "pos_status",
    "list_heading_title",
    "list_existing_title",
    "list_intervention_title",
    "get_ordered_construction",
    "app_sklopovi_a",
    "app_sklopovi_b",
    "app_sklopovi_c",
    "app_country_materijal",
    "app_country_slike",
    "app_materijali",
    "app_locales",
    "app_language",
  ],
  mixins: [mixin],
  data: function () {
    return {
      status: {},
      current_key: null,
      fixed: false,
      height: 0,
      default_materijal: {},
      current_materijal: {},
    };
  },
  methods: {
    routechange: function (index) {
      this.$emit("route_change", index);
    },
    gotolink: function (link) {
      window.open(link);
    },
    getTitle: function (key) {
      const elem = this.get_ordered_construction.find((value) => value.key == key);
      return elem.title;
    },
    toggle_position: function (key) {
      this.current_key = key;
      let elem = this.$refs["intervention" + key][0];
      if (elem.style.maxHeight) {
        elem.style.maxHeight = null;
      } else {
        elem.style.maxHeight = elem.scrollHeight + "px";
      }
      if (this.status[key]) {
        elem.addEventListener("transitionend", this.transitionend);
      } else {
        this.status[key] = !this.status[key];
      }
    },
    transitionend: function (event) {
      this.status[this.current_key] = !this.status[this.current_key];
      event.target.removeEventListener("transitionend", this.transitionend);
    },
    get_value_image: function (value) {
      return this.app_country_slike.data[value.top_image][
        value.bottom_image === "b" || value.bottom_image === "c" ? value.bottom_image : "b"
      ]
        ? this.app_country_slike.data[value.top_image][
            value.bottom_image === "b" || value.bottom_image === "c" ? value.bottom_image : "b"
          ]
        : "";
    },
    set_image: function (materijal, key) {
      let image = this.app_materijali.data[materijal].image;
      if (image) {
        this.$set(this.current_materijal, key, image);
      }
    },
  },
  mounted: function () {
    //const header = document.getElementById("app_header");
    //const menu = document.getElementById("main_menu");
    // this.$refs.main_div.style.minHeight = window.innerHeight - header.clientHeight - menu.clientHeight + "px";
    for (const key of Object.keys(this.pos_status.value)) {
      this.$set(this.status, key, false);
    }

    for (const [key, value] of Object.entries(this.pos_status.value)) {
      if (value.status == 1 && key != 10 && key != 13 && key != 60) {
        this.default_materijal[key] = this.get_value_image(value);
      }
    }
  },
};
</script>
